import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import ImageDropZone from "./ImageDropZone";
import { compressToWebP, withUploadTimeout } from "@/lib/imageCompression";

const IMAGE_SLOTS = [
  { slot: "hero", label: "Image Hero (page d'accueil)" },
  { slot: "fleet", label: "Image Flotte" },
  { slot: "essaouira", label: "Image Essaouira" },
];

const AdminPhotos = () => {
  const [images, setImages] = useState<Record<string, string>>({});

  useEffect(() => {
    supabase.from("site_images").select("*").then(({ data }) => {
      const map: Record<string, string> = {};
      data?.forEach((img) => { map[img.slot] = img.url; });
      setImages(map);
    });
  }, []);

  const uploadImage = async (slot: string, file: File) => {
    const webp = await compressToWebP(file, { maxSizeMB: 0.5 });
    const path = `${slot}.webp`;
    await supabase.storage
      .from("site-images")
      .remove([path, `${slot}.jpg`, `${slot}.jpeg`, `${slot}.png`])
      .catch(() => {});
    const { error: uploadError } = await withUploadTimeout(
      supabase.storage.from("site-images").upload(path, webp, { contentType: webp.type, upsert: true })
    );
    if (uploadError) throw new Error("Erreur upload : " + uploadError.message);
    const { data: urlData } = supabase.storage.from("site-images").getPublicUrl(path);
    const url = urlData.publicUrl + "?t=" + Date.now();
    const { error: dbError } = await supabase.from("site_images").upsert({ slot, url }, { onConflict: "slot" });
    if (dbError) throw new Error("Erreur DB : " + dbError.message);
    toast.success("Image mise à jour !");
    setImages((prev) => ({ ...prev, [slot]: url }));
  };

  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {IMAGE_SLOTS.map(({ slot, label }) => (
        <Card key={slot} className="border-border">
          <CardHeader>
            <CardTitle className="font-heading text-lg">{label}</CardTitle>
          </CardHeader>
          <CardContent>
            <ImageDropZone
              currentUrl={images[slot]}
              onUpload={(file) => uploadImage(slot, file)}
              accept="image/*"
              label="Glisser ou cliquer pour changer"
            />
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AdminPhotos;
